import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, ListMethodArg, ListMethodResponse, GetMethodResponse, ModelClass, References } from '/imports/types';

export interface Rarity extends Doc {
  _id: string;
  name: string;
  bbprice: number | null;
  bsprice: number | null;
  bbfprice: number | null;
  bsfprice: number | null;
}

type Model = Rarity;
type Refs = References<Model>;

export const Rarities = new Mongo.Collection<Rarity>('rarities');

export const listRarities = DeclareMethod<ListMethodArg<Rarity>, ListMethodResponse<Rarity, Refs>>('listRarities');
export const getRarity = DeclareMethod<string, GetMethodResponse<Rarity, Refs>>('getRarity');
export const createRarity = DeclareMethod<Partial<Rarity>, string>('createRarity');
export const updateRarity = DeclareMethod<Partial<Rarity>, string>('updateRarity');
export const deleteRarity = DeclareMethod<string, undefined>('deleteRarity');

export const modelClass: ModelClass<Model, Refs> = {
  collection: Rarities,
  editableFields: ['name', 'bbprice', 'bsprice', 'bbfprice', 'bsfprice'],
  listMethod: listRarities,
  getMethod: getRarity,
  createMethod: createRarity,
  updateMethod: updateRarity,
  deleteMethod: deleteRarity,
  pathPrefix: '/rarities',
  modelName: 'Rarity',
  pluralName: 'Rarities',
};
